import { useGateValue } from '@statsig/react-bindings';

export default function useCooperEnabled() {
  return useGateValue('cooper_rollout');
}
